export const IMAGE_PLACEMENT = {
  TOP: 'top',
  BOTTOM: 'bottom',
  NO_IMAGE: 'noImage',
} as const;

export const IMAGE_PLACEMENT_OPTIONS = {
  TOP: 'Image above content',
  BOTTOM: 'Image below content',
  NO_IMAGE: 'Hide image',
} as const;

export const normalizeImagePlacement = (contentfulImagePlacement: string | null | undefined) => {
  switch (contentfulImagePlacement) {
    case IMAGE_PLACEMENT_OPTIONS.TOP:
      return IMAGE_PLACEMENT.TOP;

    case IMAGE_PLACEMENT_OPTIONS.BOTTOM:
      return IMAGE_PLACEMENT.BOTTOM;

    case IMAGE_PLACEMENT_OPTIONS.NO_IMAGE:
      return IMAGE_PLACEMENT.NO_IMAGE;

    default:
      return undefined;
  }
};

export const HERO_MODULE_TEXT_ALIGNMENT = {
  CENTER: 'Center',
  LEFT: 'Left',
} as const;
